import _sfc_main from "./component-library130.mjs";
import "./component-library131.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _vm.text ? _c("span", { staticClass: "square-badge", class: _setup.className, attrs: { "tabindex": _vm.footnoteText || !!_vm.clickBadge !== void 0 ? 0 : void 0 }, on: { "click": _setup.handleClick } }, [_c("span", { staticClass: "square-badge__content", domProps: { "innerHTML": _vm._s(_vm.text) } }), _vm.footnoteText || _vm.clickBadge !== void 0 ? _c("span", { staticClass: "square-badge__footnote-btn btn btn--footnote" }, [_vm._v(" * ")]) : _vm._e()]) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8cf4448c",
  null,
  null
);
const SquareBadge = __component__.exports;
export {
  SquareBadge as default
};
